var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-wrapper"},[_c('div',{staticClass:"content_box"},[_c('p',[_vm._v("欢迎你，"),_c('span',[_vm._v(_vm._s(_vm.nickname))]),_vm._v(" 老师!")])])])}
var staticRenderFns = []

export { render, staticRenderFns }